import React, { Component } from "react";
import PageHead from "../../components/pageHead";
import Layout from "../../components/Layout";
import "../../sass/_contact-us.scss";
import "../../sass/_home.scss";
import "../../sass/_get-estimate.scss";
import { Container, Row, Col, Button } from "react-bootstrap";
import getConfig from "next/config";
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Cbutton from "../../components/button";
import ScrollAnimation from "react-wow";
import Header from "../../components/header";
import SERVICE from "../../rest-api/api-call.js";
import Modal from "react-bootstrap/Modal";
export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      phone_number: "",
      email: "",
      message: "",
      formValid: false,
      inValidEmail: false,
      show: false,
      validPhone: false,
    };
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  }

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  handleShow = () => {
    this.setState({
      show: true,
    });
  };

  //   handleClick(event) {
  //     const name = this.state.name;
  //     const phone = this.state.phone_number;
  //     const email = this.state.email;
  //     const message = this.state.message;
  //     const creds = {
  //       name: name,
  //       phone_number: phone,
  //       email: email,
  //       message: message,
  //     };
  //     console.log("00000000000000000000000000000 SUBMITTED DATA:", creds);
  //     this.setState({ formValid: true });
  //   if(creds.phone_number.length >= 10 && creds.phone_number.length <= 12){
  //       this.setState({ validPhone : false })
  //   }else{
  //       this.setState({ validPhone : true })
  //   }
  //     const isPhoneValid =
  //       creds.phone_number.length >= 10 && creds.phone_number.length <= 12;
  //     this.setState({ validPhone: !isPhoneValid });

  //     if (
  //       creds.name == "" ||
  //       creds.phone_number == "" ||
  //       creds.email == "" ||
  //       !this.state.validPhone ||
  //       !/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(creds.email)
  //     ) {
  //       if (!/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(creds.email)) {
  //         this.setState({
  //           inValidEmail: true,
  //         });
  //       } else {
  //         this.setState({
  //           inValidEmail: false,
  //         });
  //       }
  //       return false;
  //     }
  //     SERVICE._ContactUs(creds)
  //       .then((res) => {
  //         this.handleShow();
  //         this.setState({
  //           name: "",
  //           phone_number: "",
  //           email: "",
  //           message: "",
  // formValid: false,
  // inValidEmail: false,
  // validPhone: false,
  //         });
  //       })
  //       .catch((e) => {});

  //   }
  handleClick(event) {
    if (this.state.isSubmitting) return;
    const { name, phone_number, email, message } = this.state;

    const creds = { name, phone_number, email, message };
    this.setState({ formValid: true });

    const isPhoneValid = phone_number.length >= 10 && phone_number.length <= 12;
    this.setState({ validPhone: !isPhoneValid });

    if (
      name == "" ||
      phone_number == "" ||
      email == "" ||
      message == "" ||
      !isPhoneValid ||
      !/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(email)
    ) {
      this.setState({
        inValidEmail: !/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(email),
      });
      return;
    }

    this.setState({ isSubmitting: true });

    // fetch("/api/contact", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(creds),
    // })
    //   .then((res) => res.json())
    //   .then((data) => {
    //     if (data.success) {
    //       this.handleShow();
    //       this.setState({
    //         name: "",
    //         phone_number: "",
    //         email: "",
    //         message: "",
    // formValid: false,
    // inValidEmail: false,
    // validPhone: false,
    //       });
    //     }
    //   })
    //   .catch((err) => console.log(err));
    fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(creds),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          this.handleShow();

          this.setState({
            name: "",
            phone_number: "",
            email: "",
            message: "",
            formValid: false,
            inValidEmail: false,
            validPhone: false,
            isSubmitting: false,
          });
        } else {
          this.setState({ serverError: data.error, isSubmitting: false });
        }
      })
      .catch(() =>
        this.setState({ serverError: "Network error", isSubmitting: false })
      );
  }

  render() {
    let {
      name,
      phone_number,
      email,
      message,
      formValid,
      inValidEmail,
      show,
      validPhone,
    } = this.state;
    return (
      <div>
        <Header name="contact-us" />
        <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
        <Layout>
          <section className="devalopement-sec">
            <Container className="">
              <div className="mt-5 mb-5 pt-sm-5 pb-sm-5">
                <Row>
                  <Col md={7}>
                    <div className="pl-sm-3">
                      <div className="big-heading pt-sm-2">Get in touch</div>
                      <div className="spectial-content pt-sm-5">
                        If you’re into a new product idea, a project, a new
                        strategy or want to share a cup of coffee, come say Hi!
                      </div>
                    </div>
                  </Col>
                  <Col className="text-center spectial desktop">
                    <img
                      src={`${publicRuntimeConfig.staticFolder}/images/contact-us-top.png`}
                      alt="contact-us-top"
                      className="mt-2 w-100"
                    />
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
          <section>
            <Modal show={show} onHide={this.handleClose.bind(this)}>
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body className="text-center">
                <div className="text-center pb-2">
                  <svg
                    class="checkmark check-scss"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      class="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      class="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </div>
                <div className="spectial-content pt-5 pb-3">
                  We received your information!. <br /> Our expert team will get
                  back to you soon.
                </div>
              </Modal.Body>
            </Modal>
          </section>
          <section className="mt-5 pt-5 mb-sm-5 pb-sm-4">
            <Container>
              <Row>
                <Col className="pl-sm-0 pr-sm-0 desktop" md={5}>
                  <ScrollAnimation animation="bounceInLeft">
                    <div className="head-office-box pt-sm-5 pl-sm-4">
                      <Row>
                        <Col md>
                          <div className="case-study-heading pt-sm-1 pl-sm-4 head-office-color pt-sm-3 form-090f">
                            Let's chat
                          </div>
                          <div className="case-study-heading pt-sm-1 pl-sm-4 head-office-color pt-sm-3 form-090ppf text-white">
                            Ask us how we can
                          </div>
                          <div className="pl-sm-4 mobile-let-chat">
                            <Row>
                              <Col md={1} xs={2}>
                                <img
                                  src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`}
                                  alt="discover-arrow"
                                  className="mt-sm-4 pt-2"
                                />
                              </Col>
                              <Col>
                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color ppl text-white">
                                  Expand your ability to innovate
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={1} xs={2}>
                                <img
                                  src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`}
                                  alt="discover-arrow"
                                  className="mt-sm-4 pt-2"
                                />
                              </Col>
                              <Col>
                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color pt-sm-0 ppl text-white">
                                  Build a dynamic team
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={1} xs={2}>
                                <img
                                  src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`}
                                  alt="discover-arrow"
                                  className="mt-sm-4 pt-2"
                                />
                              </Col>
                              <Col>
                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color pt-sm-0 ppl text-white">
                                  Co-develop custom software
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div>
                            <img
                              src={`${publicRuntimeConfig.staticFolder}/images/green-flower-pot.svg`}
                              alt="green-flower-pot"
                              className="mt-sm-5 pt-sm-5 float-right"
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </ScrollAnimation>
                </Col>
                <Col className="pl-sm-0 pr-sm-0">
                  <ScrollAnimation animation="bounceInRight" className="h-100">
                    <div className="form-box pl-sm-5 pr-sm-5 pb-5">
                      <div className="footer-nav-link pl-sm-4 ser-content pt-sm-3 pb-sm-5 ">
                        Here are the ways you can contact us with any questions
                        you have
                      </div>
                      <div className="spectial pl-sm-4 pr-sm-4">
                        <div className="floating-form">
                          <div className="mb-3">
                            <div className="floating-label mb-sm-0">
                              <input
                                className={
                                  formValid && name == ""
                                    ? "floating-input error-msg-b"
                                    : "floating-input"
                                }
                                type="text"
                                placeholder=" "
                                value={name}
                                name="name"
                                onChange={(event) =>
                                  this.handleUserInput(event)
                                }
                              />
                              <span className="highlight"></span>
                              <label
                                className={
                                  formValid && name == "" ? "error-msg" : ""
                                }
                              >
                                Name*
                              </label>
                            </div>
                            {formValid && name == "" && (
                              <span className="error-msg">
                                Please enter name
                              </span>
                            )}
                          </div>
                          <div className="pt-5 mb-3">
                            <div className="floating-label mb-sm-0">
                              <input
                                className={
                                  (formValid && phone_number == "") ||
                                  validPhone
                                    ? "floating-input error-msg-b"
                                    : "floating-input"
                                }
                                type="text"
                                placeholder=" "
                                value={phone_number}
                                name="phone_number"
                                onChange={(event) =>
                                  this.handleUserInput(event)
                                }
                              />
                              <span className="highlight"></span>
                              <label
                                className={
                                  (formValid && phone_number == "") ||
                                  validPhone
                                    ? "error-msg"
                                    : ""
                                }
                              >
                                Phone Number*
                              </label>
                            </div>
                            {((formValid && phone_number == "") ||
                              validPhone) && (
                              <span className="error-msg">
                                Please enter phone number with country code
                              </span>
                            )}
                          </div>
                          <div className="pt-5 mb-3">
                            <div className="floating-label mb-sm-0">
                              <input
                                className={
                                  formValid && email == "" && inValidEmail
                                    ? "floating-input error-msg-b"
                                    : "floating-input"
                                }
                                type="text"
                                placeholder=" "
                                value={email}
                                name="email"
                                onChange={(event) =>
                                  this.handleUserInput(event)
                                }
                              />
                              <span className="highlight"></span>
                              <label
                                className={
                                  (formValid && email == "") || inValidEmail
                                    ? "error-msg"
                                    : ""
                                }
                              >
                                Email*
                              </label>
                            </div>
                            {formValid && email == "" && inValidEmail && (
                              <span className="error-msg">
                                Please enter valid email
                              </span>
                            )}
                          </div>
                          <div className="pt-5 mb-3">
                            <div className="floating-label mb-sm-0">
                              <textarea
                                className={
                                  formValid && email == ""
                                    ? "floating-input floating-textarea error-msg-b"
                                    : "floating-input floating-textarea"
                                }
                                type="text"
                                placeholder=" "
                                value={message}
                                name="message"
                                onChange={(event) =>
                                  this.handleUserInput(event)
                                }
                              />
                              <span className="highlight"></span>
                              <label
                                className={
                                  formValid && message == "" ? "error-msg" : ""
                                }
                              >
                                Message*
                              </label>
                            </div>
                            {formValid && message == "" && (
                              <span className="error-msg">
                                Please enter message
                              </span>
                            )}
                          </div>
                          {/* <div
                            className="mt-5 pt-3 pb-5 width-content"
                            onClick={(event) => this.handleClick(event)}
                          >
                            <Cbutton name="Submit" extra={true} />
                          </div> */}
                          <div
                            className="mt-5 pt-3 pb-5 width-content"
                            onClick={(event) =>
                              !this.state.isSubmitting &&
                              this.handleClick(event)
                            }
                            style={{
                              pointerEvents: this.state.isSubmitting
                                ? "none"
                                : "auto",
                            }}
                          >
                            <Cbutton
                              name={
                                this.state.isSubmitting
                                  ? "Submitting..."
                                  : "Submit"
                              }
                              extra={true}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="pl-4">
                                                <HubspotForm
                                                    portalId='6826765'
                                                    formId='e299f2e3-4e04-4c10-a2c9-b4eac140877f'
                                                    onSubmit={() => console.log('Submit!')}
                                                    onReady={(form) => console.log('Form ready!')}
                                                    loading={<div>Loading...</div>}
                                                />
                                            </div> */}
                    </div>
                  </ScrollAnimation>
                </Col>
                <Col className="pl-sm-0 pr-sm-0 mobile" md={5}>
                  <ScrollAnimation animation="bounceInLeft">
                    <div className="head-office-box pt-sm-5 pl-sm-4">
                      <Row>
                        <Col md>
                          <div className="case-study-heading pt-sm-1 pl-sm-4 head-office-color pt-sm-3 form-090f">
                            Let's chat
                          </div>
                          <div className="case-study-heading pt-sm-1 pl-sm-4 head-office-color pt-sm-3 form-090ppf text-white">
                            Ask us how we can
                          </div>
                          <div className="pl-sm-4 mobile-let-chat">
                            <Row>
                              <Col md={1} xs={2}>
                                <img
                                  src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`}
                                  alt="discover-arrow"
                                  className="mt-sm-4 pt-2"
                                />
                              </Col>
                              <Col>
                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color ppl text-white">
                                  Expand your ability to innovate
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={1} xs={2}>
                                <img
                                  src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`}
                                  alt="discover-arrow"
                                  className="mt-sm-4 pt-2"
                                />
                              </Col>
                              <Col>
                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color pt-sm-0 ppl text-white">
                                  Build a dynamic team
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={1} xs={2}>
                                <img
                                  src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`}
                                  alt="discover-arrow"
                                  className="mt-sm-4 pt-2"
                                />
                              </Col>
                              <Col>
                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color pt-sm-0 ppl text-white">
                                  Co-develop custom software
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div>
                            <img
                              src={`${publicRuntimeConfig.staticFolder}/images/green-flower-pot.svg`}
                              alt="green-flower-pot"
                              className="mt-sm-5 pt-sm-5 float-right"
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </ScrollAnimation>
                </Col>
              </Row>
              <Row className="mobile pt-4 pb-4">
                <Col className="text-center spectial">
                  <img
                    src={`${publicRuntimeConfig.staticFolder}/images/contact-us-top.png`}
                    alt="contact-us-top"
                    className="mt-2 w-100"
                  />
                </Col>
              </Row>
            </Container>
          </section>
          <section>
            {/* <img src={`${publicRuntimeConfig.staticFolder}/images/map-sd.svg`} alt="map-sd" className="talk-sps-img" /> */}
            <Container>
              <Row>
                <Col>
                  <div className="dev-c-c mb-3">Development Centre</div>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.509312611754!2d78.39033125000918!3d17.435320505952426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb937a44ed6d41%3A0x4a784e7054dd8cfc!2sAXLR%20DATA%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1579271170052!5m2!1sen!2sin"
                    height="450"
                    frameBorder="0"
                    style={{ border: "0px solid", width: "90%" }}
                    allowFullScreen=""
                  ></iframe>
                  <div className="case-study-heading mt-5">Hyderabad</div>
                  <div className="footer-nav-link ser-content address-text pt-sm-2 pb-sm-2 mr-sm-4">
                    Plot No. 59,SY No. 47, Amar Co-Operative Society, Kavuri
                    Hills, Hyderabad, Telangana 500032
                  </div>
                  <div className="case-study-heading">Phone</div>
                  <div className="footer-nav-link ser-content address-text pt-sm-2 mr-sm-4">
                    +91 9966436789
                  </div>
                  <div className="footer-nav-link ser-content address-text pb-sm-2 mr-sm-4">
                    +91 9700523118
                  </div>
                  <div className="case-study-heading">Email</div>
                  <div className="footer-nav-link ser-content address-text pt-sm-2 pb-sm-2 mr-sm-4 pb-sm-5">
                    hello@axlrdata.com
                  </div>
                </Col>
                <Col>
                  <div className="dev-c-c mb-3">Corporate Office</div>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2941.5344241943653!2d-71.125939549396!3d42.501449684051956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e374c72db63945%3A0xb00eb27491491f1f!2sPlanet%20Satellite!5e0!3m2!1sen!2sin!4v1581531094569!5m2!1sen!2sin"
                    height="450"
                    frameborder="0"
                    style={{ border: 0, width: "90%" }}
                    allowfullscreen=""
                  ></iframe>
                  <div className="case-study-heading mt-5">Boston</div>
                  <div className="footer-nav-link ser-content address-text pt-sm-2 pb-sm-2 mr-sm-4">
                    10 Tower Office Park, Suite 500, Woburn, MA 01801
                  </div>
                  <div className="case-study-heading">Phone</div>
                  <div className="footer-nav-link ser-content address-text pt-sm-2 mr-sm-4">
                    +91 9966436789
                  </div>
                  <div className="footer-nav-link ser-content address-text pb-sm-2 mr-sm-4">
                    +91 9700523118
                  </div>
                  <div className="case-study-heading">Email</div>
                  <div className="footer-nav-link ser-content address-text pt-sm-2 pb-sm-2 mr-sm-4 pb-sm-5">
                    hello@axlrdata.com
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          {/* <section className="mt-sm-5 mb-sm-5 pt-sm-5 pb-sm-5">
                        <img src={`${publicRuntimeConfig.staticFolder}/images/map-sd.svg`} alt="map-sd" className="talk-sps-img" />
                        <Container>
                            <Row className="justify-content-md-center">
                                <Col md={8}>
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.509312611754!2d78.39033125000918!3d17.435320505952426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb937a44ed6d41%3A0x4a784e7054dd8cfc!2sAXLR%20DATA%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1579271170052!5m2!1sen!2sin" height="450" frameBorder="0" style={{ border: 0, width: "100%" }} allowFullScreen=""></iframe>
                                </Col>
                            </Row>
                        </Container>
                    </section> */}
        </Layout>
        <style>
          {`
                    body{
                        overflow-x: hidden;
                    }
                    .form-090f {
                        letter-spacing: 6px;
                        font-size: 50px;
                        color: #fff !important;
                        font-family: "PT Mono", monospace;
                    }
                    .text-white{
                        color:#ffffff !important;
                        line-height: 30px !important;
                    }
                    @media only screen and (max-width: 768px){
                        .big-heading {
                            font-size: 40px !important;
                            line-height: 55px !important;
                            padding-bottom: 25px;
                            padding-top: 35px !important;
                            letter-spacing: 0px;
                        }
                        .mobile-wi-c{
                            width:90%
                        }
                        .more-cases{
                            line-height: 25px !important;
                            margin-top: 25px !important;
                        }
                        .form-090f {
                            letter-spacing: 6px;
                            font-size: 50px;
                            color: #fff !important;
                            font-family: "PT Mono", monospace;
                            padding-top:20px;
                        }
                        .dev-c-c{
                            line-height: 55px;
                            margin-top: 40px;
                        }
                    }
                    `}
        </style>
      </div>
    );
  }
}
